import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';
import { useApp } from './context/app-context';
import LandingPageV2 from './components/LandingPageV2';
import WebViewRoute from './WebViewRoute';
import RouteProvider from './context/route-context';
import LandingPageMobile from './components/LandingPage/LandingPageMobile';
import { restoreConsole } from './utils/utils';

function App() {
  const { appData } = useApp();

  useEffect(() => {
    if (localStorage.getItem('abNgSubscriptions')) {
      localStorage.removeItem('abNgSubscriptions');
    }
  }, []);

  useEffect(() => {
    restoreConsole();
  });

  return (
    <Router basename="schedule-and-save">
      <RouteProvider routeData={undefined}>
        <Switch>
          <PrivateRoute
            exact
            path={['/manage', '/manage.html']}
            title={`Manage Schedule`}
            banner={appData.banner}
            component={LandingPageV2}
          />
          <WebViewRoute
            path={['/manage/mobile/view']}
            title={`Manage Schedule`}
            banner={appData.banner}
            component={LandingPageMobile}
          />
        </Switch>
      </RouteProvider>
    </Router>
  );
}

export default App;
